export default __webpack_public_path__ + "static/media/awesong.195dd020.png";